import { CaptureSection } from '../../../components/capture/CaptureSection';
import { IdentificationSection } from '../../../components/identification/IdentificationSection';

export function IdentificationPanel({
  mode,
  setMode,
  imageData,
  isIdentifying,
  error,
  result,
  onImageCapture
}) {
  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">
        Plant Identification
      </h1>

      <CaptureSection
        mode={mode}
        setMode={setMode}
        onImageCapture={onImageCapture}
        imageData={imageData}
      />

      {(isIdentifying || error || result) && (
        <div className="mt-6">
          <IdentificationSection
            isIdentifying={isIdentifying}
            error={error}
            result={result}
          />
        </div>
      )}
    </div>
  );
}
